import httpclient from "@/api/http-client";
export default {
  async getChats(orderId) {
    return await httpclient
      .get(`/api/Orders/orderAdminNotes?orderId=${orderId}`)
      .then((res) => res.data)
      .catch(() => true);
  },
  async postChat(orderId, message, emailAddress, userId) {
    let payload = {
      "id": orderId,
      "orderPrivateId": 0,
      "text": message,
      "emailAddress": emailAddress,
      "createdBy": userId,
      "updatedBy": userId
    }

    return await httpclient
      .post(`/api/Orders/addOrderAdminNotes`, payload)
      .then((res) => console.log(res))
      .catch(() => true);
  },
  async deleteChat(noteId) {
    return await httpclient
      .delete(`/api/Orders/deleteOrderAdminNote?noteId=${noteId}`)
      .then((res) => console.log(res))
      .catch(() => true);
  }
}
